import React from "react";
import classNames from "classnames";
import "./tabbable.scss";

export default ({ className, children, ...props }) => (
  <button onMouseDown={e => e.preventDefault()} className={classNames("tabbable", className)} {...props}>
    {children}
  </button>
);
